const e=()=>({defaultProps:{disableRipple:!0}});export{e as default};
